import { DietTextAndAction } from 'modules/activities/components/overview/DietTextAndAction'
import { CalendarItemNode } from '../types.graphql'
import {
  DriverDietForm,
  DriverDietPrompt,
} from 'modules/activities/components/overview/DriverDietPrompt'
import { usePrompt } from '@ur-solutions/react-components'
import { useDietDayMutations } from 'modules/activities/mutations.hooks'

export const DietButton: React.FC<{
  calendarItem: CalendarItemNode
  userId: string
  canEdit?: boolean
  border?: boolean
  onClick?: () => void
}> = ({ calendarItem, userId, canEdit, border, onClick }) => {
  const addPrompt = usePrompt()
  const dietMutations = useDietDayMutations()
  async function handleAddDriverDiet() {
    const { data } = await addPrompt<DriverDietForm | null>(resolve => (
      <DriverDietPrompt
        initialData={{
          userId: userId,
          salaryCodeId: calendarItem?.driverDiet?.salaryCode?.id ?? null,
          partOfDay: calendarItem?.driverDiet?.partOfDay ?? 1,
        }}
        edit={!!calendarItem?.driverDiet}
        onSubmit={resolve}
      />
    ))
    if (data === null) return

    dietMutations.updateOrCreateDriverDiet({
      variables: {
        input: {
          ...data,
          calendarItem: calendarItem.id,
        },
      },
    })
  }
  return (
    <DietTextAndAction
      diet={calendarItem.driverDiet}
      canEdit={canEdit}
      border={border}
      onClick={handleAddDriverDiet}
    />
  )
}
